import { render } from "./TokenizeProperty.vue?vue&type=template&id=02ba5da1"
import script from "./TokenizeProperty.vue?vue&type=script&lang=js"
export * from "./TokenizeProperty.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__